import React from 'react';
import Layout from 'sections/Layout';

import Hero from 'sections/common/Hero';
import WrapContainer from 'sections/ResourceCenter/WrapContainer';
import ScreverInActionSec from 'sections/common/ScreverInAction';
// import LocaleSelect from 'components/LocaleSelect';

// import useAllResourceCenterPosts from 'hooks/graphql/useAllResourceCenterPosts';

const ResourceCenter = ({ page }) => {
  const {
    template: {
      resourceCenter: {
        resourceCenterHeroSection: {
          resourceCenterHeroTitle,
          resourceCenterHeroSubtitle,
        },
        sectionsBuilderResourceCenter,
      },
    },
    seo,
  } = page;

  // const allResourceCenterPosts = useAllResourceCenterPosts();

  const heroData = {
    title: resourceCenterHeroTitle,
    subtitle: resourceCenterHeroSubtitle,
    langSwitcherTitle: null,
  };

  const heroStyles = {
    color: '#716FFF',
    background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1180' height='343' fill='none' viewBox='0 0 1180 343'%3E%3Cpath stroke='%23231F20' stroke-linejoin='round' stroke-width='4' d='M679.636 340.433a32.29 32.29 0 0 1 5.468-14.321 32.5 32.5 0 0 1 11.471-10.216 31.117 31.117 0 0 1-12.585-11.007A30.831 30.831 0 0 1 678.959 289a29.446 29.446 0 0 1-5.53 16.631A31.669 31.669 0 0 1 658 316.259a23.994 23.994 0 0 1 16.173 7.559 20.129 20.129 0 0 1 4.641 7.691 19.991 19.991 0 0 1 .822 8.924ZM1153.16 271.108c.39-4.212-.22-8.451-1.79-12.363a26.249 26.249 0 0 0-7.22-10.124 25.14 25.14 0 0 0 11.81-6.613 25.51 25.51 0 0 0 6.73-11.808 24.278 24.278 0 0 0 1.43 14.217 25.446 25.446 0 0 0 10.25 11.134c-4.9-.785-9.93.378-14.02 3.245a16.632 16.632 0 0 0-4.99 5.335c-1.24 2.132-2 4.517-2.2 6.977ZM938.898 312.029c1.246-16.023 3.84-32.97 14.32-45.295 6.641-7.806 15.877-12.942 24.49-18.488 8.612-5.547 17.329-11.915 21.791-21.159 3.531-7.19 4.151-15.407 6.021-23.213 4.15-17.152 15.98-33.381 32.89-38.311-34.24-12.633-67.862-26.191-101.483-40.263-11.415 5.136-23.037 11.299-28.329 22.494-5.084 10.682-3.424 23.418-6.848 34.819-2.076 6.779-6.019 13.044-11.207 17.872-7.575 6.882-17.433 10.682-25.527 16.845-15.358 11.606-23.555 31.943-20.65 50.944 18.782 12.839 41.196 21.159 62.364 29.478 11 4.314 21.065 9.963 32.168 14.277Z'/%3E%3Cpath stroke='%23231F20' stroke-linejoin='round' stroke-width='4' d='M924.372 166.281c2.386-1.643 4.773-3.389 7.471-4.314 2.698-.924 5.915-1.027 8.302.514 3.113 1.848 4.462 5.752 4.669 9.346.208 4.622-1.038 9.347-3.528 13.353-1.764 2.773-5.5 5.238-8.094 3.389-2.49-1.848-1.556-5.649-.104-8.319 2.076-3.801 5.085-7.19 8.821-9.244 3.839-2.055 8.612-2.568 12.452-.719 3.735 1.746 6.33 5.546 7.16 9.552.83 4.006.103 8.319-1.557 12.017-.622 1.335-1.349 2.568-2.49 3.39-1.142.821-2.906 1.027-4.047.102-.934-.719-1.245-2.054-1.245-3.184-.416-6.471 4.046-12.736 10.065-15.098 6.019-2.363 13.179-1.13 18.471 2.67M902.476 206.34c19.716 7.6 39.016 16.228 57.798 25.986M903.513 224.313c9.858 4.828 19.612 9.758 29.47 14.585M895.317 230.887c8.094 6.574 16.084 13.147 24.074 19.721M838.451 95c-.415 6.574-.726 13.352 1.038 19.721 1.764 6.368 5.915 12.428 12.037 14.995 6.226 2.465 14.424.411 17.329-5.546 2.906-5.957-1.971-14.585-8.613-13.969-6.433.514-9.857 7.704-10.688 13.969-1.867 14.174 3.425 29.17 13.905 39.03M815 158.373c12.452 6.677 24.904 13.455 37.356 20.132M817.387 206.853c12.037-1.644 23.97-3.39 36.007-5.033M395.326-66.094c285.845-319.513 575.37 386.132 24.209 46.975-551.16-339.157 269.443-504.798-15.191 6.894-284.634 511.692-372.252-32.67 95.587-45C967.77-69.556 335.821 533.744 278.808 44.739 221.795-444.265-13.467 390.85 395.326-66.094Z'/%3E%3C/svg%3E")`,
  };

  return (
    <Layout
      seo={seo}
      headerDarkColor={true}
      headerWhiteBg={true}
      requestButtonBlue={true}
    >
      {(commonData) => (
        <>
          <Hero
            data={heroData}
            color={heroStyles.color}
            background={heroStyles.background}
          />

          {/* <LocaleSelect data={allResourceCenterPosts} /> */}
          <WrapContainer data={sectionsBuilderResourceCenter} />
          <ScreverInActionSec />
        </>
      )}
    </Layout>
  );
};

export default ResourceCenter;
